export const COEFFICIENTS = {
    '1': 'Single',
    '2': 'Double',
    '4': 'Quadruple',
    '8': 'Octuple',
} as const
